module.exports = __webpack_public_path__ + "img/sp1.7915090a.svg";